import { Component, Inject, Input } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle
} from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { format, parse } from 'date-fns';
import moment from 'moment';
import { NgxMatTimepickerComponent, NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ESTIMATED_OFF_HIRE_DIALOG } from 'src/testIds';
import { HireItemService } from '../..';
import { HireItem } from '../../../models';
import { TestIdDirective } from '../../directives/test-id.directive';

@Component({
  selector: 'add-estimated-off-hire-dialog',
  templateUrl: './add-estimated-off-hire-dialog.component.html',
  styleUrls: ['./add-estimated-off-hire-dialog.component.css'],
  providers: [HireItemService],
  standalone: true,
  imports: [
    MatDialogTitle,
    ReactiveFormsModule,
    MatDialogContent,
    MatButton,
    TestIdDirective,
    MatFormField,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatIcon,
    NgxMatTimepickerModule,
    MatLabel,
    MatError,
    MatSuffix,
    MatDialogActions
  ]
})
export class AddEstimatedOffHireDialogComponent {
  @Input() hireItem: HireItem;

  testIds = ESTIMATED_OFF_HIRE_DIALOG;
  formGroup = new UntypedFormGroup({
    offHireDate: new UntypedFormControl(
      moment().add(1, 'day'),
      Validators.required
    ),
    offHireTime: new UntypedFormControl(
      format(moment().add(1, 'day').toDate(), 'HH:mm'),
      Validators.required
    )
  });

  constructor(
    public dialogRef: MatDialogRef<AddEstimatedOffHireDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private hireItemService: HireItemService
  ) {
    if (data.hireItem) {
      this.hireItem = data.hireItem;
    }
  }

  quickDate(qty: number, unit: string) {
    let offHire = moment()
      .add(<any>unit, <any>qty)
      .toISOString();
    this.saveOffHireDate(offHire);
  }

  submit() {
    let offHire = parse(
      this.formGroup.value.offHireTime,
      'HH:mm',
      this.formGroup.value.offHireDate.toDate()
    ).toISOString();
    this.saveOffHireDate(offHire);
  }

  saveOffHireDate(offHire: string) {
    this.hireItem.estimated_off_hire = offHire;
    this.hireItemService
      .update(this.hireItem.id, this.hireItem.docket_id, this.hireItem)
      .subscribe(
        (response) => {
          this.hireItem = Object.assign(this.hireItem, response);
          this.dialogRef.close(offHire);
        },
        (error) => {
          this.hireItem.estimated_off_hire = null;
          throw error;
        }
      );
  }


  updateTime(event: any, field: string) {
    this.formGroup.get(field).patchValue(event);
  }

  updateTimeEnteredManually(field: string, picker: NgxMatTimepickerComponent) {
    const control = this.formGroup.get(field);
    if (!control.value) {
      return;
    }
    // 24 hr patterns to try and parse
    const parsePatterns = ['HH:mm', 'HH.mm', 'H:mm', 'HHmm', 'Hmm', 'HH', 'H'];
    const invalidValue = control.value;
    for (const pattern of parsePatterns) {
      const parsed = parse(invalidValue, pattern, new Date());
      if (parsed.toString() !== 'Invalid Date') {
        control.patchValue(format(parsed, 'HH:mm'));
        return picker.updateTime(control.value);
      }
    }
    control.setErrors({ invalidTime: true });
  }
}
